@if (condition) {
  <div class="visitor-type-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      @if (visitorRoles != null && visitorRoles.length > 0) {
        <mat-form-field class="flex-grow" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.visit.visitor-role-condition-editor.visitor-role"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="visitorRole" name="visitorRole">
            @for (o of visitorRoles; track o) {
              <mat-option [value]="o.id">
                <sc-dictionary-label [dictionaryKey]="o.nameDictionaryKey"></sc-dictionary-label>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>
}
